import React from 'react';
import { useSelector } from 'react-redux';
import { InfoIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/components/capstone/base';
import {
  NOTIFIED_AGENCY,
  RESPONSIBLE_AGENCY,
} from '@rsos/constants/alertsRoutingConstants';
import {
  NotificationContainer,
  NotificationContentWrapper,
} from './AlertDataCardNotification.styles';
import { emergencyTypeMapper } from './utils';

const AlertDataCardNotification = ({ alert }) => {
  const agencyLinks = useSelector(state => state.alertsRouting.agencyLinks);
  const formattedEmergencyType = emergencyTypeMapper(
    alert?.emergency_type?.name,
  );
  const formattedEmergencyTypeTitle = emergencyTypeMapper(
    alert?.emergency_type?.name,
    true,
  );
  const { linksTo } = agencyLinks;
  const wasAlertShared =
    alert?.associated_role_type === RESPONSIBLE_AGENCY &&
    linksTo?.length &&
    linksTo.find(l =>
      l.attributes.alert_emergency_types.find(
        t => t === formattedEmergencyType,
      ),
    );
  if (alert.associated_role_type === NOTIFIED_AGENCY) {
    return (
      <NotificationContainer>
        <NotificationContentWrapper>
          <InfoIcon width={16} height={16} />
          <Text size="normal">
            Information Only: Received from your paired agency
          </Text>
        </NotificationContentWrapper>
      </NotificationContainer>
    );
  } else if (wasAlertShared) {
    return (
      <NotificationContainer>
        <NotificationContentWrapper>
          <InfoIcon width={16} height={16} />
          <Text size="normal">
            You are sharing {formattedEmergencyTypeTitle} Alerts with your
            paired agencies
          </Text>
        </NotificationContentWrapper>
      </NotificationContainer>
    );
  } else {
    return null;
  }
};

export default AlertDataCardNotification;
